<template>
  <div class="menu-tree">
    <template v-for="menu in menuData">
      <template v-if="menu.menuType === 1">
        <el-submenu :key="menu.menuId" :index="menu.menuLink" v-if="menu.children && menu.children.length > 0">
          <template slot="title">
            <i class="iconfont iconfont-c" :class="menu.icon"></i>
            <span slot="title">{{ menu.menuName }}</span>
          </template>
          <menu-tree :menuData="menu.children"></menu-tree>
        </el-submenu>
        <template v-else>
          <el-menu-item :index="menu.menuLink" :key="menu.menuId">
            <i class="iconfont iconfont-c" :class="menu.icon"></i>
            <span slot="title">{{ menu.menuName }}</span>
          </el-menu-item>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  props: ["menuData"],
  name: "MenuTree",
};
</script>
<style lang="scss">
//.menu-tree {
//  .el-icon-arrow-down:before {
//    content: "\e790";
//  }
//}
</style>
<style lang="scss" scoped>
.menu-tree {
  .iconfont-c {
    font-size: 0.18rem;
    margin-right: 0.12rem;
  }
}
</style>
